import { types } from "../../../types/types";
import { fetchConToken } from "../../../helpers/fetch";
import { startSpinner, finishSpinner } from "../../ui/spinner";
import { handleErrorApi } from "../../../helpers/randoms";
import { startAlerta } from "../../ui/alertas";

export const FetchPatologias = () => async (dispatch) => {
    try {
        const response = await fetchConToken(`Patologias`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmPracticasAgrupadasTraerTiposSuccess,
                payload: body
            });
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las patologias", "Ha ocurrido un error. Intente nuevamente")
        dispatch({ type: types.abmPatologiasError });
    }
};

export const AgregarPatologia = (descripcion) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        let datos = {
            Descripcion: descripcion
        }

        const response = await fetchConToken(`Patologias`, datos, "POST");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Patologia creada correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPatologias());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear una nueva Patologia.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const ModificarPatologia = (idPatologia, descripcion) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`Patologias/${idPatologia}`, descripcion, "PUT");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Patologia modificada correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPatologias());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar la patologia.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const EliminarPatologia = (idPatologia) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Patologias/${idPatologia}`, '', "DELETE");
        const body = await response.json(); 

        if(response.ok){
            dispatch(startAlerta("Patologia eliminada correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPatologias());
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(startAlerta(error.errores.mensaje ? error.errores.mensaje : "Ha ocurrido un error en el servidor", 'error', "Error"))
    }
};

export const BuscarPatologia = (text) => (dispatch) =>{
    dispatch({
        type : types.abmPracticasAgrupadasBuscarTipo,
        payload : text
    });
}